import React from "react";
import "./Loader.css";
import { THEME_COLOR } from "../../utils/colors";

interface LoaderProps {
    fullScreen?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ fullScreen = false }) => {
    return (
        <div className={fullScreen ? "loader-container full-screen" : "loader-container"}>
            <div
                className="spinner"
                style={{ borderTopColor: THEME_COLOR }}
            />
        </div>
    );
};

export default Loader;
